import { IPlaceSuggestion, PlaceSearchErrorKind } from 'src/utils/places/autocomplete'

export interface IPlaceSearchState {
  currentId: number;
  status: 'idle' | 'loading' | 'ready' | 'error';
  slow: boolean;
  answered: boolean;
  suggestions: IPlaceSuggestion[];
  error?: PlaceSearchErrorKind;
}

export type PlaceSearchAction =
  | { type: 'reset'; id: number }
  | { type: 'started'; id: number }
  | { type: 'slow'; id: number }
  | { type: 'succeeded'; id: number; suggestions: IPlaceSuggestion[] }
  | { type: 'failed'; id: number; error: PlaceSearchErrorKind }

export const initialPlaceSearchState: IPlaceSearchState = {
  answered: false,
  currentId: 0,
  slow: false,
  status: 'idle',
  suggestions: []
}

export const placeSearchReducer = (
  state: IPlaceSearchState,
  action: PlaceSearchAction
): IPlaceSearchState => {
  switch (action.type) {
    case 'reset':
      return { ...initialPlaceSearchState, currentId: action.id }
    case 'started':
      return { ...state, currentId: action.id, error: undefined, slow: false, status: 'loading' }
    case 'slow':
      return action.id === state.currentId && state.status === 'loading'
        ? { ...state, slow: true }
        : state
    case 'succeeded':
      return action.id === state.currentId
        ? { ...state, answered: true, error: undefined, slow: false, status: 'ready', suggestions: action.suggestions }
        : state
    case 'failed':
      return action.id === state.currentId
        ? { ...state, answered: true, error: action.error, slow: false, status: 'error', suggestions: [] }
        : state
  }
}
